// Chinese display labels for the canonical ApplicationStage values. The stored
// value (applications.md / DB / API payloads) is ALWAYS the English canonical
// string — this map only affects what the UI shows. Never write these back.
export const STAGE_LABEL_ZH: Record<string, string> = {
  Evaluated: '已评估',
  Applied: '已申请',
  Responded: '已回复',
  'Phone screen': '电话初筛',
  Interview: '面试',
  Interviewing: '面试中',
  Offer: 'Offer',
  Rejected: '已拒绝',
  Discarded: '已放弃',
  SKIP: '跳过',
};

/** Display label for a canonical stage. Falls back to the raw value. */
export function stageLabel(stage: string, zh: boolean): string {
  return zh ? (STAGE_LABEL_ZH[stage] ?? stage) : stage;
}
